import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { PainPoints } from '../components/PainPoints';
import { HowItWorks } from '../components/HowItWorks';
import { WhatWeHelpWith } from '../components/WhatWeHelpWith';
import { Testimonials } from '../components/Testimonials';
import { MeetTheTeam } from '../components/MeetTheTeam';
import { AntiDietBlock } from '../components/AntiDietBlock';
import { LeadMagnet } from '../components/LeadMagnet';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-stone-900" style={{
    '--accent': '#4bc041'
  } as React.CSSProperties} data-id="element-180">
      <Navbar data-id="element-181" />
      <main data-id="element-182">
        <HeroSection data-id="element-183" />
        <PainPoints data-id="element-184" />
        <HowItWorks data-id="element-185" />
        <WhatWeHelpWith data-id="element-186" />
        <Testimonials data-id="element-187" />
        <MeetTheTeam data-id="element-188" />
        <AntiDietBlock data-id="element-189" />
        <LeadMagnet data-id="element-190" />
      </main>
      <Footer data-id="element-191" />
    </div>;
}